export const isDateValid = (value: string): boolean => {
  const date = new Date(value);
  return Object.prototype.toString.call(date) === '[object Date]' ? !isNaN(date.getTime()) : false;
};
